import { render, staticRenderFns } from "./editcrowdname.vue?vue&type=template&id=ec083598&scoped=true"
import script from "./editcrowdname.vue?vue&type=script&lang=js"
export * from "./editcrowdname.vue?vue&type=script&lang=js"
import style0 from "./editcrowdname.vue?vue&type=style&index=0&id=ec083598&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec083598",
  null
  
)

export default component.exports